// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__bG6qy","thumb":"Switch_thumb__9b02Q"};